import React from 'react';
import './chip-link.scss';
import { Chip, Link } from '@material-ui/core';
import { ChipLinkProps } from './chip-link-props';

/**
 * A link displayed as a chip.
 *
 * Extends the `Link` props.
 * @param props
 */
export const ChipLink: React.FC<ChipLinkProps> = (props) => {
  const {
    disabled,
    children,
  } = props;

  return (
    <div className="sg-chip-link">
      {!disabled && (
        <Link
          {...props}
        >
          <Chip
            label={children}
          />
        </Link>
      )}
      {disabled && (
        <Chip
          label={children}
          disabled
        />
      )}
    </div>
  );
};
